<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="720px"
    :close-on-click-modal="false"
    class="upload-box"
    :class="{ show: dialogVisible }"
  >
    <template #title>
      选择工具
      <el-select
        v-model="toolType"
        popper-class="supportTool-select-popper"
        placeholder="仪表类型"
        @change="toolTypeChange"
      >
        <el-option
          v-for="(item, index) in toolTypes"
          :key="index"
          :label="item.name"
          :value="item.type"
        >
        </el-option>
      </el-select>
    </template>
    <!-- 工具 -->
    <div class="tool-wrap">
      <!-- 多参数换算 -->
      <MultiConvert v-show="toolType === '1'" />

      <!-- 单位换算 -->
      <UnitConvert v-show="toolType === '2'" />

      <!-- 材料选择指南 -->
      <div v-if="toolType === '3'" class="tool-wrap-item">
        <div class="tool-wrap-item-content third">
          <Search
            ref="search03"
            class="my-search"
            :searchConfig="tableConfig03"
            @doSearch="doSearch03"
          >
          </Search>
          <!-- 列表 -->
          <Table ref="table03" class="my-table" :tableConfig="tableConfig03">
          </Table>
        </div>
      </div>
      <div v-show="toolType === '4'" class="tool-wrap-item">
        <div class="tool-wrap-item-content">
          <ImageCom
            :preview="true"
            style="width: 100%"
            :src="require('@/assets/img/meterSelection/speed.png')"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import Search from '@/components/search/index'
import Table from '@/components/table/index'
import ImageCom from '@/components/image/index.vue'
import MultiConvert from './multiConvert.vue'
import UnitConvert from './unitConvert.vue'

export default {
  name: 'supportTool',
  components: { ImageCom, Search, Table, MultiConvert, UnitConvert },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        // 判断是否可编辑
        this.$nextTick(() => {
          // 初始化
        })
      }
    }
  },
  data () {
    return {
      toolType: '1',
      toolTypes: [
        { name: '多参数换算', type: '1' },
        { name: '单位换算', type: '2' },
        { name: '材料选择指南', type: '3' },
        { name: '流速选择推荐', type: '4' }
      ],
      // 材料选择指南
      tableConfig03: {
        searchUrl: '/front/cross/commodity-user/design/material/list', // 搜索接口
        searchMethod: 'POST', // 接口请求方式
        autoSearch: false, // 是否需要默认查询
        needPagination: true, // 是否需要分页
        resultListName: 'dataList',
        maxHeight: '400px',
        paginationLayout: 'total, prev, pager, next',
        params: [
          {
            prop: 'mediumList',
            selected: () => {
              this.$refs.search03.setField('materialList', [])
            },
            placeholder: '选择介质',
            searchType: 'multipleRemoteSelect',
            searchValueType: 'array',
            options: [],
            popperClass: 'supportTool-select-popper',
            multipleRemoteSelected: [],
            queryStringLength: 1,
            searchProps: {
              url: '/front/cross/commodity-user/design/material/mediumValues', // 接口路径
              key: 'value', // 搜索字段
              resultListName: 'dataList',
              extra: {
                page: 1,
                limit: 30
              },
              method: 'POST' // 请求方式
            },
            hideInTable: true
          },
          {
            prop: 'materialList',
            label: '或',
            selected: () => {
              this.$refs.search03.setField('mediumList', [])
            },
            searchType: 'multipleRemoteSelect',
            searchValueType: 'array',
            options: [],
            popperClass: 'supportTool-select-popper',
            multipleRemoteSelected: [],
            queryStringLength: 1,
            searchProps: {
              url: '/front/cross/commodity-user/design/material/materialValues', // 接口路径
              key: 'value', // 搜索字段
              resultListName: 'dataList',
              extra: {
                page: 1,
                limit: 30
              },
              method: 'POST' // 请求方式
            },
            placeholder: '选择材料',
            hideInTable: true
          },
          {
            prop: 'medium',
            label: '介质',
            hideInSearch: true
          },
          {
            prop: 'maxConcentration',
            label: '最大浓度',
            width: 80,
            hideInSearch: true
          },
          {
            prop: 'material',
            label: '材料',
            hideInSearch: true
          },
          {
            prop: 'level',
            label: '等级',
            width: 75,
            hideInSearch: true
          },
          {
            prop: 'performance',
            label: '综合表现',
            align: 'left',
            hideInSearch: true
          }
        ],
        extra: {
          // 额外参数
        }
      }
    }
  },
  methods: {
    // 工具类型切换
    toolTypeChange (val) {
      if (val === '3') {
        this.$nextTick(() => {
          this.doSearch03()
        })
      }
    },

    // 材料选择指南查询
    doSearch03 () {
      this.tableConfig03.extra = {
        ...this.$refs.search03.getParams()
      }
      this.$refs.table03.getList()
    },
    handleClose () {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>
<style lang="scss">
.supportTool-select-popper {
  font-family: Alibaba PuHuiTi;
}
</style>
<style lang="scss" scoped>
.upload-box {
  transition: transform 0.3s ease-in-out;
  animation: none !important;
  display: block !important;
  overflow: hidden;
  transform: translateX(100%);
  text-align: right;

  &.show {
    transform: translateX(0);
  }

  &::after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 100%;
  }

  /deep/ .el-dialog {
    margin: 0 !important;
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    margin-right: 15px !important;
    height: calc(100% - 50px);
    border-radius: 8px;
    background: #fafbfe;

    .el-dialog__header {
      border-bottom: 1px solid #eee;
      padding: 5px 28px;
      background: #fff;
      border-radius: 8px 8px 0 0;
      font-size: 18px;
      font-weight: bold;
      color: #333;

      .el-select {
        margin-left: 17px;
      }

      .el-dialog__headerbtn {
        top: 16px;
      }
    }

    .el-dialog__body {
      max-height: calc(100vh - 103px);
      overflow: auto;
      padding: 0;
    }

    // 下拉选择重写样式
    .el-select {
      .el-select__caret:first-child::before {
        content: "\e6e1";
      }

      .is-focus {
        .el-select__caret:first-child {
          transform: rotateZ(0deg);
        }
      }

      .el-input {
        input {
          background: #f6f5fa;
          padding-left: 10px;
          border: none;
          font-size: 16px;
          color: #333;
          font-family: Alibaba PuHuiTi;
        }
      }

      .el-select__tags {
        .el-tag {
          background: #fff;
        }
      }
    }

    // table重写样式
    .el-table {
      border-radius: 8px;
      color: rgba(0, 0, 0, 0.9);
      border-color: rgba(0, 0, 0, 0.05) !important;

      .el-loading-mask {
        right: 1px;
        bottom: 1px;
      }

      th.el-table__cell {
        background-color: #f1f5fb;
        // font-weight: 500;
        font-size: 14px;
        border-bottom: none;

        > .cell {
          padding: 0;
        }
      }

      thead {
        color: rgba(0, 0, 0, 0.9);
      }

      &.el-table--border {
        .el-table__cell {
          border-right: none;
        }
      }

      &.el-table--striped {
        .el-table__body {
          tr.el-table__row--striped {
            td.el-table__cell {
              background-color: #fff;
            }
          }
        }
      }
      &.el-table--enable-row-hover {
        .el-table__body {
          tr:hover {
            > td.el-table__cell {
              background-color: #f5f7fa;
            }
          }
        }
      }
    }

    // 数字输入框
    .custom-input-number {
      width: 100%;

      .el-input__inner {
        text-align: left;
        padding: 0 10px;
        color: rgba(0, 0, 0, 0.9);
        font-family: Alibaba PuHuiTi;
      }

      .el-input-number__decrease,
      .el-input-number__increase {
        display: none;
      }
    }
  }
}

.tool-wrap {
  .tool-wrap-item,
  /deep/ .tool-wrap-item {
    padding: 19px 11px 17px 19px;

    .tool-wrap-item-content {
      border-radius: 8px;
      background: #fff;
      overflow: hidden;

      &.first {
        padding: 12px;
      }

      &.second {
        padding: 24px 12px;
        margin-bottom: 19px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      &.third {
        padding: 12px;

        .my-search {
          .search-list {
            margin-bottom: 12px;

            .item {
              width: 50%;

              &.search-btns {
                display: none;
              }

              &:nth-child(1) {
                .label {
                  display: none;
                }
              }

              .label {
                min-width: auto;
                text-align: center;
                padding-right: 12px;
                color: #2a54d1;
                font-size: 14px;
                font-weight: bold;

                &::after {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
